import React from 'react';
import { connect } from 'react-redux';
import TotalChart from 'components/pages/comparison/charts/totalchart';
import RangeChart from 'components/pages/comparison/charts/rangechart';
import DailyChart from 'components/pages/comparison/charts/dailychart';
import { getNodeSeriesStats, getStatsDaily, getComparisonParams } from 'actions/stats';
import {
    RECEIVE_FIRST_LOCATION_TOTAL, RECEIVE_FIRST_LOCATION_DAILY, RECEIVE_FIRST_LOCATION_RANGE,
    RECEIVE_SECOND_LOCATION_TOTAL, RECEIVE_SECOND_LOCATION_DAILY, RECEIVE_SECOND_LOCATION_RANGE
} from 'actions/comparison'
export class Charts extends React.Component {
    componentWillReceiveProps(nextProps) {
        this.getStats(nextProps, 0);
        this.getStats(nextProps, 1);
    }
    getStats(nextProps, location) {
        if (nextProps.comparisonStats.nodes !== this.props.comparisonStats.nodes ||
            nextProps.querySettings != this.props.querySettings) {
            let id = nextProps.comparisonStats.nodes[location].id;
            let card = this.props.cards[nextProps.comparisonStats.nodes[location].info.cardid];
            let tagType = nextProps.comparisonStats.nodes[location].type;
            let params = getComparisonParams({ querySettings: nextProps.querySettings }, id, card, tagType);
            console.log("params to fetch")
            console.log(params)
            if (location === 0) {
                let params1 = Object.assign({}, params);
                params1.action = RECEIVE_FIRST_LOCATION_TOTAL;
                this.props.dispatch(getNodeSeriesStats(params1));
                let params2 = Object.assign({}, params);
                params2.action = RECEIVE_FIRST_LOCATION_DAILY;
                this.props.dispatch(getStatsDaily(params2));
                let params3 = Object.assign({}, params);
                params3.action = RECEIVE_FIRST_LOCATION_RANGE;
                params3.groupby = 'hour';
                this.props.dispatch(getNodeSeriesStats(params3));
            } else {
                let params1 = Object.assign({}, params);
                params1.action = RECEIVE_SECOND_LOCATION_TOTAL;
                this.props.dispatch(getNodeSeriesStats(params1));
                let params2 = Object.assign({}, params);
                params2.action = RECEIVE_SECOND_LOCATION_DAILY;
                this.props.dispatch(getStatsDaily(params2));
                let params3 = Object.assign({}, params);
                params3.action = RECEIVE_SECOND_LOCATION_RANGE;
                params3.groupby = 'hour';
                this.props.dispatch(getNodeSeriesStats(params3));
            }
        }
    }
    render() {
        let first = {};
        let second = {};
        let isMeetingRoom = false;
        if (this.props.comparisonStats.nodes[0] && this.props.comparisonStats.nodes[1]) {
            first = this.props.comparisonStats.nodes[0];
            second = this.props.comparisonStats.nodes[1];
            // if isMeetingRoom is true, display TagSelector on charts
            isMeetingRoom = this.props.comparisonStats.nodes[0].type === "meeting_room" &&
                this.props.comparisonStats.nodes[0].type === this.props.comparisonStats.nodes[1].type
        }
        return (

            <div className="comparison-stats-cards-wrapper">
                <TotalChart isMeetingRoom={isMeetingRoom} querySettings={this.props.querySettings} stats={this.props.comparisonStats.total} first={first} second={second} />
                <RangeChart isMeetingRoom={isMeetingRoom} querySettings={this.props.querySettings} stats={this.props.comparisonStats.range} first={first} second={second} />
                <DailyChart isMeetingRoom={isMeetingRoom} querySettings={this.props.querySettings} stats={this.props.comparisonStats.daily} first={first} second={second} />
            </div>


        );
    }
}

function mapStateToProps(state) {
    return {
        comparisonStats: state.comparisonReducer,
        querySettings: state.querySettingsReducer,
        cards: state.defaultSettingsReducer.card
    };
}
function mapDispatchToProps(dispatch) {
    return {
        dispatch
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(Charts);




// WEBPACK FOOTER //
// ./src/components/pages/comparison/charts/index.jsx